import authStore from '@/shared/store/authStore'

const authState = authStore({
  state: {},
})

export default authState
